export const MINIMUM_ASSETS_NUMBER_FOR_TOWER_SIDE_PROFILE = 1
export const MAXIMUM_ASSETS_NUMBER_FOR_TOWER_SIDE_PROFILE = 2
export const REQUIRED_3D_MODELS_NUMBER_FOR_TOWER_SIDE_PROFILE = 1
export const MAXIMUM_STRUCTURE_MODELS_NUMBER_FOR_TOWER_SIDE_PROFILE = 1
